import React from "react"
import * as v2layouts from "../layouts"

interface BulkActionsProps {
	selectedCount: number
	totalCount: number
	onSelectAll: () => void
	onDeselectAll: () => void
	onSendToSettings: () => void
	onSendToTraining: () => void
}

export function BulkActions({
	selectedCount,
	totalCount,
	onSelectAll,
	onDeselectAll,
	onSendToSettings,
	onSendToTraining,
}: BulkActionsProps): JSX.Element {
	return (
		<v2layouts.BottomActionBar>
			<v2layouts.ActionBarText>
				{selectedCount > 0 ? `${selectedCount} of ${totalCount} selected` : `${totalCount} total assets`}
			</v2layouts.ActionBarText>

			<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
				{selectedCount === totalCount && totalCount > 0 ? (
					<v2layouts.ActionButton onClick={onDeselectAll}>Deselect All</v2layouts.ActionButton>
				) : (
					<v2layouts.ActionButton onClick={onSelectAll}>Select All</v2layouts.ActionButton>
				)}

				<v2layouts.ActionButton disabled={selectedCount === 0} onClick={onSendToTraining}>
					Send {selectedCount > 0 ? selectedCount : ""} to Training
				</v2layouts.ActionButton>

				<v2layouts.ActionButton $variant="primary" disabled={selectedCount === 0} onClick={onSendToSettings}>
					Send {selectedCount > 0 ? selectedCount : ""} to Settings
				</v2layouts.ActionButton>
			</div>
		</v2layouts.BottomActionBar>
	)
}
